import {mapActions, mapGetters} from "vuex";
import _ from 'lodash'

export default {
    name: "select-category",
    data() {
        return {
            selectedCategory: {}
        }
    },
    watch: {
        '$route'(newVal) {
            if (newVal.query) {
                this.selectedCategory = newVal.query;
            }
        }
    },
    created() {
        this.fetchCategories()
        if (this.$route.query) {
            this.selectedCategory = this.$route.query
        }
    },
    computed: {
        ...mapGetters({
            getList: `category/list`,
        })
    },
    methods: {
        ...mapActions({
            fetchList: 'category/GET_LIST_CATEGORY',
            fetchCategories: `category/GET_LIST`,
        }),

        selectFilter($event) {
            if ($event.target.name === 'group') {
                // When selecting a category, reset all filters
                this.selectedCategory = {
                    category: $event.target.value,
                    seller: ''
                }
                // Reset all other filters by not including them in params
            } else if ($event.target.name === 'seller') {
                // When selecting a seller, find its parent category
                for (let i in this.getList) {
                    let category = this.getList[i]
                    if (category.sellers !== undefined) {
                        category.sellers.forEach(seller => {
                            if (seller.slug === this.selectedCategory.seller) {
                                this.selectedCategory.category = category.slug
                            }
                        })
                    }
                }
            }

            // For category selection, use only the selectedCategory
            // For seller selection, preserve existing query params
            const params = $event.target.name === 'group'
                ? { ...this.selectedCategory, skip: 0 }
                : { ...this.$route.query, ...this.selectedCategory, skip: 0 };

            this.$router.push({
                path: this.$route.path,
                query: params
            }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });

            // Call sendRequest to ensure products are updated
            this.sendRequest();
        },
        sendRequest: _.debounce(function () {
            this.fetchList(this.$route.query);
        }, 300),
    }
}
